import * as actionTypes from "./actionTypes";
import * as campaignService from "./service";
import { applyFilter } from "../../utils/general";

const log = require("loglevel").getLogger("CampaignActions");
log.setLevel("error");

export const loadCampaignById = (id, loadStats) => {
  return async (dispatch) => {
    log.debug("CampaignActions -> loadCampaignById -> Enter");

    const campaign = await campaignService.loadCampaignById(id, loadStats);
    await dispatch({
      type: actionTypes.CAMPAIGN_LOADED,
      data: campaign,
    });
  };
};

export const saveCampaign = (campaign, callback) => {
  return async (dispatch) => {
    log.debug("CampaignActions -> saveCampaign -> Enter");

    const result = await campaignService.saveCampaign(campaign);
    callback?.(result);
  };
};

export const removeCampaignContact = (
  campaignId,
  contactId,
  contactEmail,
  callback
) => {
  return async (dispatch) => {
    log.debug("CampaignActions -> removeCampaignContact -> Enter");
    const result = await campaignService.removeCampaignContact(
      campaignId,
      contactId,
      contactEmail
    );
    callback?.(result);
  };
};
export const addCampaignContact = (
  campaignIds,
  contacts,
  callback
) => {
  return async (dispatch) => {
    log.debug("CampaignActions -> addCampaignContact -> Enter");
    const result = await campaignService.addCampaignContact(
      campaignIds,
      contacts,
      );
    callback?.(result);
  };
};

export const loadCampaignMembers = (campaignId) => {
  return async (dispatch) => {
    log.debug("CampaignActions -> loadCampaignMembers -> Enter");

    const members =
      (await campaignService.loadCampaignMembers(campaignId)) ?? [];

    await dispatch({
      type: actionTypes.CAMPAIGN_MEMBERS_LOADED,
      data: members,
      campaignId,
    });
  };
};

export const activateCampaign = (
  campaignId,
  vendor,
  replyCampaignId,
  isManual,
  callback
) => {
  return async (dispatch) => {
    log.debug("CampaignActions -> activateCampaign -> Enter");

    const result = await campaignService.activateCampaign(
      campaignId,
      vendor,
      replyCampaignId,
      isManual
    );
    await dispatch(loadCampaignById(campaignId));
    callback?.(result);
  };
};

export const resumeCampaign = (campaignId, replyCampaignId,isManual, callback) => {
  return async (dispatch) => {
    log.debug("CampaignActions -> resumeCampaign -> Enter");

    const result = await campaignService.resumeCampaign(
      campaignId,
      replyCampaignId,
      isManual
    );
    await dispatch(loadCampaignById(campaignId));
    callback?.(result);
  };
};

export const pauseCampaign = (campaignId, replyCampaignId,isManual, callback) => {
  return async (dispatch) => {
    log.debug("CampaignActions -> pauseCampaign -> Enter");

    const result = await campaignService.pauseCampaign(
      campaignId,
      replyCampaignId,
      isManual
    );
    await dispatch(loadCampaignById(campaignId));
    callback?.(result);
  };
};

export const deleteCampaign = (campaignId, callback) => {
  return async (dispatch) => {
    log.debug("CampaignActions -> deleteCampaign -> Enter");

    const result = await campaignService.deleteCampaign(campaignId);
    callback?.(result);
  };
};

export const getReplyCampaigns = () => {
  return async (dispatch) => {
    log.debug("CampaignActions -> getReplyCampaigns -> Enter");

    const result = await campaignService.getReplyCampaigns();
    console.log("getReplyCampaigns:", result);
  };
};

export const loadCampaigns = (selectedFilters) => {
  return async (dispatch) => {
    log.debug("CampaignActions -> loadCampaigns -> Enter");

    const campaigns =
      (await campaignService.loadCampaigns(selectedFilters)) ?? [];

    let filteredCampaigns = campaigns;
    selectedFilters?.forEach((filter) => {
      filteredCampaigns = applyFilter(filteredCampaigns, filter);
    });

    await dispatch({
      type: actionTypes.CAMPAIGNS_LOADED,
      data: filteredCampaigns,
    });
  };
};

export const loadDropdownValues = (key) => {
  return async (dispatch) => {
    log.debug("CampaignActions -> loadDropdownValues -> Enter");

    const dropdownValues =
      (await campaignService.loadDropdownValues(key)) ?? [];

    await dispatch({
      type: actionTypes.DROPDOWN_VALUES_LOADED,
      data: dropdownValues,
      key,
    });
  };
};
// add get member dict statuss members/status
export const getMemberStatus = (callback) => {
  return async (dispatch) => {
    log.debug("CampaignActions -> getMemberDict -> Enter");

    const memberDict = (await campaignService.loadCampaignMembersStatus()) ?? [];
    callback?.(memberDict);
    await dispatch({
      type: actionTypes.MEMBER_DICT_LOADED,
      data: memberDict,
    });
  };
};
// add update member status members/update
export const updateMemberStatus = (campaignId, contactId, status, callback) => {
  return async (dispatch) => {
    log.debug("CampaignActions -> updateMemberStatus -> Enter");

    const result = await campaignService.updateCampaignMemberStatus(
      campaignId,
      contactId,
      status
    );
   
    callback?.(result);
  };
};

export const addRelativeAccountsToContact = (
  campaignId,
  contactId,
  relatedAccounts,
  callback
) => {
  return async (dispatch) => {
    log.debug("CampaignActions -> addRelativeAccountsToContact -> Enter");
    const result = await campaignService.addRelativeAccountsToContact(
      campaignId,
      contactId,
      relatedAccounts,
      );
    callback?.(result);
  };
};